import { EntiteModel } from "./pilotage/contextePilotageUtilisateurModel";

export interface UtilisateursManagmentState {
  selectedEntreprises: EntiteModel[];
  selectedNames: string[];
  selectedEmails: string[];
  selectedRoles: string[];
  selectionEtiquette: number[];
  filter: 'all' | 'active' | 'inactive' | 'invitation';
  searchTerm: string;
  pageIndex: number;
  pageSize: number;
}

export const defaultUtilisateursManagmentState: UtilisateursManagmentState = {
  selectedEntreprises: [],
  selectedNames: [],
  selectedEmails: [],
  selectedRoles: [],
  selectionEtiquette: [],
  filter: 'active',
  searchTerm: '',
  pageIndex: 0,
  pageSize: 10
};

export function validateUtilisateursManagmentState(state: any): UtilisateursManagmentState {
  if (!state || typeof state !== 'object') {
    return { ...defaultUtilisateursManagmentState };
  }

  return {
    selectedEntreprises: Array.isArray(state.selectedEntreprises) ? state.selectedEntreprises : [],
    selectedNames: Array.isArray(state.selectedNames) ? state.selectedNames : [],
    selectedEmails: Array.isArray(state.selectedEmails) ? state.selectedEmails : [],
    selectedRoles: Array.isArray(state.selectedRoles) ? state.selectedRoles : [],
    selectionEtiquette: Array.isArray(state.selectionEtiquette) ? state.selectionEtiquette : [],
    filter: ['all', 'active', 'inactive', 'invitation'].includes(state.filter) ? state.filter : 'active',
    searchTerm: typeof state.searchTerm === 'string' ? state.searchTerm : '',
    pageIndex: typeof state.pageIndex === 'number' && state.pageIndex >= 0 ? state.pageIndex : 0,
    pageSize: typeof state.pageSize === 'number' && state.pageSize > 0 ? state.pageSize : 10
  };
}
